<template>
    <DetailComponent
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :parent_id="parent_id"
        :rest_api_note="rest_api_note"
        :title_page="title_page"
        :single_object="single_object"
        :array_options="array_options"
        :form_format="form_format"
        :notes="single_object.notes"
        :back_href="'/assignment-shifts'"
        @elementsGetter="elementsGetter($event)"
    />    
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import DetailComponent  from    '@/components/DetailComponent/DetailComponent'
import { Notyf }        from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'ShiftDetail',
    components: {
        DetailComponent
    },
    
    data(){
        return{
            notyf,
            parent_id:          this.$route.params.id,
            rest_api:           `shifts/${this.$route.params.id}`,
            lite_rest_api:      `shifts`,
            rest_api_note:      `shift_notes`,
            form_format:        FormResources.form_format,
            breadcrumb:         Resources.breadcrumb,
            shift_options:      FormResources.shift_options,
            title_page:         '',
            content_header:     this.$store.state.headers,
            single_object:      {},
            array_options:      {},
        }
    },

    methods:{

        fill_data(data) {
            this.single_object  = data.shift
            this.title_page     = this.single_object.description
            this.breadcrumb[2].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.description,
                href:   '#',
                arrow:  " ",
            })

        },

        elementsGetter(data)
        {
            this.single_object = data.data
        }
        

    },

    watch: {
    },

    async mounted(){
        await this.api_request(this.rest_api)

        this.array_options = {
            class: this.shift_options
        }
    }
}
</script>